/* @flow */
import LocalSettings from "nexia_mobile/models/local_settings";
import Schema from "nexia_mobile/models/schema";
import type { RoomIqFeature } from "./types";

export default function RoomIq(feature: RoomIqFeature) {
  this.createRoomIqSchema = () => {
    return fetch(feature.href, {
      headers: {
        "Content-Type": "application/json",
        "X-MobileId": LocalSettings.getMobileId(),
        "X-ApiKey": LocalSettings.getApiKey(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.success) {
          throw new Error("Server error.");
        }
        return new Schema(data.result, { parse: true });
      });
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/room_iq.js